module.exports = __webpack_public_path__ + "img/go-build.8bbaf04f.jpg";